export default "__VITE_ASSET__BpuztVFd__"